/**
 * Removes what the OpenAI ad pixel left behind (ADR-0162, which replaces
 * ADR-0145). From 31 October to early November 2026 the site loaded that pixel
 * for visitors who accepted the cookie banner. It set __oppref (30 days),
 * __obref (365 days) and __oaiq_consent (30 days), and we stored the banner
 * choice in localStorage. None of it is used any more, so clear it on the next
 * visit. Safe to delete this file after November 2027, when __obref has expired
 * everywhere.
 */

const PIXEL_COOKIES = ['__oppref', '__obref', '__oaiq_consent'] as const;
const STORAGE_KEYS = ['logpulse-ad-consent', 'oaiq_consent'] as const;

let done = false;

export function removeLegacyAdTracking(): void {
  if (done || typeof window === 'undefined') return;
  done = true;

  const host = window.location.hostname;
  // The SDK wrote on the host and on the registrable domain; clear both.
  const domains = ['', host, `.${host.split('.').slice(-2).join('.')}`];
  for (const name of PIXEL_COOKIES) {
    if (!document.cookie.includes(`${name}=`)) continue;
    for (const domain of domains) {
      document.cookie = `${name}=; Max-Age=0; Path=/${domain ? `; Domain=${domain}` : ''}`;
    }
  }
  try {
    for (const key of STORAGE_KEYS) localStorage.removeItem(key);
  } catch {
    /* storage blocked: nothing was stored either */
  }
}
